import { CLIENT_METHODS, RESOURCES, useApiMutation } from '@/data/api'

export const useValidateEmail = (): ReturnType<typeof useApiMutation> =>
  useApiMutation(RESOURCES.VALIDATE_EMAIL, CLIENT_METHODS.PATCH)
